import React, {useState, useRef, useEffect} from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import careerImage from "../images/career-image.png";
import recordsImage from "../images/records-image.png";
import housingImage from "../images/housing-image.png";
import disabilityImage from "../images/disability-image.png";
import memorialImage from "../images/memorial-image.png";
import healthImage from "../images/health-image.png";
import socialImage from "../images/social-image.png";
import financialImage from "../images/financial-image.png";
import findJob from "../images/find-job.png";
import homelessImage from "../images/homeless-image.png";
import homedImage from "../images/housed-image.png";
import educationImage from "../images/education-image.png";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import improveBusiness from "../images/improve-business.png";
import startBusiness from "../images/start-business.png";

const descriptionDict = {
    Career: "VetNav is committed to serving veterans who are looking for meaningful employment and opportunities to advance economically. VetNav ensures that veterans receive access to the resources they need to start a new career. ",
    Education: "VetNav helps veterans complete their education as a first step towards realizing a purpose-driven life. VetNav provides a list of resources to finance your education, receive tutoring, find a mentorship program, and more. ",
    Health: "VetNav prioritizes the physical and mental health of the veteran community. VetNav connects veterans to the services they need to meet their unique health challenges and help manage chronic illnesses, disabilities, injuries, and mental health challenges. ",
    Housing: "VetNav connects all veterans to the housing services that are right for them. VetNav provides a comprehensive resource guide for veterans at every stage of their housing journey. ",
    Social: "VetNav connects veterans to programs and resources that promote social enrichment, including volunteer opportunities, civic engagement, professional networking, and peer support resources. ",
    Financial: "VetNav supports veterans and their families who are experiencing financial hardships. VetNav also provides information on investing, financial tools, and how to protect investments. ",
    "Disability & Pension": "VetNav helps veterans looking to secure disability compensation from the VA. VetNav connects veterans with disabilities to employment opportunities, job training programs, resources to modify their homes, and more. ",
    Memorial: "VetNav ensures that veterans receive dignified funerals and burial services. ",
    Records: "VetNav assists veterans looking for records information and discharge upgrade assistance. VetNav also connects veterans to free legal assistance. ",
}

const imageDict = {
    Career: careerImage,
    Education: educationImage,
    Health: healthImage,
    Housing: housingImage,
    Social: socialImage,
    Financial: financialImage,
    "Disability & Pension": disabilityImage,
    Memorial: memorialImage,
    Records: recordsImage,
    "Do you want to find a job?": findJob,
    "Do you want to improve your business?": improveBusiness,
    "Do you want to start a business?": startBusiness,
    "Are you homeless or in danger of becoming homeless?": homelessImage,
    "Are you housed?": homedImage,
}

export const SecondPage = (props) => {
    const {
        questions,
        selections,
        setSelections,
        configurationData,
        screenSize,
    } = props

    const [hovered, setHovered] = useState(null)
    const [imageWidth, setImageWidth] = useState(null)

    const pictureRef = useRef(null);

    let emergencyButton = null;
    if (selections[0] === "None") {
        emergencyButton = ( 
            <a href={"https://www.mountsinai.org/locations/urgent-care"} target="_blank" className="emergency-button">
                 {`Are you in need of immediate medical assistance?`}
             </a>
        )
    }

    const getImage = (selections) => {
        if (imageDict[selections[selections.length - 1]]) {
            return imageDict[selections[selections.length - 1]]
        } else {
            return imageDict[selections[0]]
        }
    }
    return (
        <div className="second-page-content" >
            <div className={`header-text long ${screenSize === 'small' ? 'small-screen' : ''}`}>
                {selections[selections.length - 1]}
            </div>
            <div className={`question-banner-description ${screenSize === 'small' ? 'small-screen' : ''}`}>
                {descriptionDict[selections[0]]}
            </div>
            <div className="page-content">
                {/* <div className="progress-bar-container">
                    <div className="progress-bar-title">
                        Progress
                    </div>
                    <div className="progress-bar">
                        {`${selections.length}/4`}
                    </div>
                </div> */}
                {emergencyButton && (
                    <div className="emergency-button-container">
                        {emergencyButton}
                    </div>
                )}
                <div className={`second-page-list ${emergencyButton ? 'short' : ''} ${screenSize === 'small' ? 'small-screen' : ''}`} id="child">
                    {
                        questions?.map(category => {
                            const categoryRow = configurationData.find(csvRow => (
                                csvRow[5] === category
                            ))
                            const description = categoryRow[11]
                            const isEmergency = categoryRow[12] == 1
                            return (
                                <div className="question-item-container">
                                    <div 
                                        key={category}
                                        className={`second-page-list-item ${isEmergency ? 'emergency' : ''} ${screenSize === 'small' ? 'small-screen' : ''}`}
                                        onClick={() => (setSelections([...selections, category]))}
                                        onMouseEnter={() => setHovered(category)}
                                        onMouseLeave={() => setHovered(null)}
                                    >
                                        <div className="second-page-list-item-content">
                                            <div className={`second-page-list-item-row ${screenSize === 'small' ? 'small-screen' : ''}`}>
                                                <div className={`second-page-list-icon ${screenSize === 'small' ? 'small-screen' : ''}`}>
                                                    <div className="briefcase-icon">
                                                        <ChevronRightIcon 
                                                            style={{
                                                                fontSize: screenSize === 'small' ? '3.4vw' : '1.4vw',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    {category}
                                                </div>
                                            </div>
                                            <div className="second-page-list-item-divider" />
                                            <div className={`second-page-list-item-row bottom ${screenSize === 'small' ? 'small-screen' : ''}`}>
                                                <div className={`second-page-list-item-subheader ${screenSize === 'small' ? 'small-screen' : ''}`}>
                                                    {description || category}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="second-page-list-item-icon">
                                            {hovered !== category ? 
                                                <PlayArrowOutlinedIcon style={{
                                                    width: screenSize === 'small' ? '6vw' : '3vw', 
                                                    height: screenSize === 'small' ? '7vw' : '3.5vw'
                                                }}/> :
                                                <PlayArrowIcon style={{
                                                    width: screenSize === 'small' ? '6vw' : '3vw', 
                                                    height: screenSize === 'small' ? '7vw' : '3.5vw'
                                                }}/>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                { screenSize !== 'small' && (
                    <div className="picture-content" ref={pictureRef}>
                        <img 
                            className="banner-image"
                            src={getImage(selections)}
                            alt="bannerImage"
                        />
                </div>
                )}
            </div>
        </div>
    )
}